import noUiSlider from 'nouislider';
import wNumb from 'wnumb';
import {Filter} from '../filter/filter'

class RangeSlider {

  constructor(elem) {
    this.range = elem;
    this.id = this.range.attr('id');
    this.min = parseInt(this.range.attr('data-min')) || 0;
    this.max = parseInt(this.range.attr('data-max')) || 100;
    this.startMin = parseInt(this.range.attr('data-start-min')) || min;
    this.startMax = parseInt(this.range.attr('data-start-max')) || max;
    this.connect = Boolean(this.range.attr('data-connect')) || false;
    this.slider = document.getElementById(this.id);
    this.dataInputs = Boolean(this.range.parent().find('[data-inputs]').length > 0);
    this.dataValues = Boolean(this.range.parent().find('[data-values]').length > 0);
    this.tooltips = this.range.is('data-tooltips') || false;
    this.tooltip = false;
    this.init = 0;
    this.inputs, this.skipValues;
    this.resetBtn = $('[data-filter-reset]');
	}

  initialize() {
    let filter = undefined;

    // tooltip
    if (this.tooltips) {
      this.tooltip = wNumb({decimals: 0});
    }

    // инпуты
    if (this.dataInputs) {
      this.inputs = [
        document.getElementById(this.id + '-min'),
        document.getElementById(this.id + '-max')
      ];
    }

    // строковые значения
    if (this.dataValues) {
      this.skipValues = [
        document.getElementById(this.id + '-val-min'),
        document.getElementById(this.id + '-val-max')
      ];
    }

    noUiSlider.create(this.slider, {
      start: [this.startMin, this.startMax],
      connect: this.connect,
      range: {
        'min': this.min,
        'max': this.max
      },
      format: wNumb({
        decimals: 0
      }),
      tooltips: [this.tooltip, this.tooltip]
    });

    // если это фильтр, то создаем экземпляр класса
    if (this.range.closest('[data-filter]').length > 0) {
      filter = new Filter(this.range.closest('[data-filter]'));
    }

    // обновление слайдера при перетаскивании кружков
    this.slider.noUiSlider.on('update', (values, handle) => {
      if (this.dataInputs) {
        this.inputs[handle].value = parseInt(values[handle]).toLocaleString('ru');
      }

      if (this.dataValues) {
        this.skipValues[handle].innerHTML = values[handle];
      }

      if ((this.range.attr('data-filter-range') == '') && (this.init > 2)) {
        this.range.addClass('selected');

        if (filter != undefined) {
          filter.isReset();
        }
      }

      this.init++;
    });

    // обработчик события 'end' слайдера цены
    // вызывает метод для обновления фильтра и список товаров
    this.slider.noUiSlider.on('end', (values, handle) => {
      filter.sliderEndEventHandler(this);
    });

    // обновление слайдера при вводе значений вручную
    if (this.dataInputs) {
      this.inputs.forEach((input, handle) => {
        input.addEventListener('input', (e) => {
          this.slider.noUiSlider.setHandle(handle, e.target.value);
          if (this.range.attr('data-filter-range') == '') {
            this.range.addClass('selected')
          }
        });
      });
    }

    // сброс значений слайдера
    this.resetBtn.on('click', (e) => {
      if (filter != undefined) {
        this.reset(filter)
      }
    })
	}

  // сброс значений слайдера
  reset(filter) {
    this.slider.noUiSlider.reset();
    this.range.removeClass('selected');

    if (filter != undefined) {
      filter.isReset();
    }
  }
}

export {RangeSlider};

$(window).on('load', () => {
  let range = [];

  if ($('[data-range]').length > 0) {
		$('[data-range]').each(function(i) {
			range[i] = new RangeSlider($(this));
			range[i].initialize();
		});
	}
});
